import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgHttpLoaderModule } from 'ng-http-loader';
import { provideNgxMask } from 'ngx-mask';
import { AuthInterceptor } from '../core/interceptors/auth.interceptor';
import { Api } from '../core/api-common-service/api';


export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        Api,
        provideNgxMask(),
        // importProvidersFrom( NgHttpLoaderModule.forRoot(),ImageViewerModule.forRoot()),
         importProvidersFrom(
      HttpClientModule,
      NgHttpLoaderModule.forRoot()
    ),
        provideRouter(routes)
    ],
};